import React, { useState, useEffect, useRef } from 'react'
import './Document.css'
import PropTypes from 'prop-types'
import Spinner from '../../utilities/spinner/Spinner'
import { Document, Page } from 'react-pdf/dist/entry.webpack'
import { pdfjs } from 'react-pdf'
import { FullScreen, useFullScreenHandle } from 'react-full-screen'
//MUI
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import ZoomOutMapIcon from '@material-ui/icons/ZoomOutMap'
//Redux
import { setErrors } from '../../redux'
import { useSelector, useDispatch } from 'react-redux'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

function DocumentWindow(props) {
  const { file } = props
  const [myFile, setMyFile] = useState(file)
  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)
  const [isFullScreen, setIsFullScreen] = useState(false)
  const [viewportWidth, setViewportWidth] = useState(10)
  const [documentClassName, setDocumentClassName] = useState('preview')
  const [pageToolClassName, setPageToolClassName] = useState('absolute-page-tool')
  const [errorMsg, setErrorMsg] = useState('')

  const ui = useSelector((state) => state.ui)
  const myDocument = useSelector((state) => state.document)
  const dispatch = useDispatch()
  const myRef = useRef()
  const handle = useFullScreenHandle()

  useEffect(() => {
    setPageNumber(1)
    setMyFile(file)
  }, [file])

  const handleError = (error) => {
    setErrorMsg(error.message + ' Please reject the file.')
    dispatch(setErrors(error))
  }

  const onPageLoadSuccess = (e) => removeTextLayerOffset()

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages)
    setViewportWidth(myRef.current.offsetWidth - 15)
  }

  const removeTextLayerOffset = () => {
    const textLayers = document.querySelectorAll('.react-pdf__Page__textContent')
    textLayers.forEach((layer) => {
      const { style } = layer
      style.top = '0'
      style.left = '0'
      style.transform = ''
    })
  }

  const goToPrevPage = () => {
    if (pageNumber > 1) setPageNumber((prevPageNumber) => prevPageNumber - 1)
    else if (pageNumber === 1) setPageNumber(numPages)
  }

  const goToNextPage = () => {
    if (pageNumber < numPages) setPageNumber((prevPageNumber) => prevPageNumber + 1)
    else if (pageNumber === numPages) setPageNumber(1)
  }

  const toggleFullScreen = (isFull) => {
    if (isFull) handle.enter()
    else handle.exit()
    setIsFullScreen(isFull)
    setDocumentClassName(isFull ? 'fullscreen' : 'preview')
    setPageToolClassName(isFull ? 'fixed-page-tool' : 'absolute-page-tool')
    setViewportWidth(isFull ? window.outerWidth : myRef.current.offsetWidth - 15)
  }

  const handleEscapeKey = (state,handle)=>{
    if(!state)
    toggleFullScreen(state)
  }

  let pageToolMarkup = file && !ui.errors && (
    <div className={pageToolClassName} >
      <ArrowBackIosIcon fontSize='large' className='window-icon' onClick={goToPrevPage} />
      <p style={{ color: 'white' }}>
        Page {pageNumber} of {numPages}
      </p>
      <ArrowForwardIosIcon fontSize='large' className='window-icon' onClick={goToNextPage} />
      <ZoomOutMapIcon fontSize='large' className='window-icon' onClick={() => toggleFullScreen(!isFullScreen)} />
    </div>
  )

  let documentMarkup = !myDocument.loading ? (
    <FullScreen handle={handle}  onChange={handleEscapeKey}  >
      <div 
        className='window-container'
        style={{
          width: myRef.current && myRef.current.offsetWidth && !isFullScreen ? myRef.current.offsetWidth : '100%',
          height: myRef.current && myRef.current.offsetHeight && !isFullScreen ? myRef.current.offsetHeight : '100%',
          animation: 'transitionIn 0.75s',
        }}
      >
        {pageToolMarkup}

        <div className={documentClassName}>
          <Document
            file={myFile}
            onLoadSuccess={onDocumentLoadSuccess}
            loading={<Spinner />}
            onLoadError={handleError}
            error={errorMsg}

          >
            <Page
              renderTextLayer={true}
              pageNumber={pageNumber}
              width={viewportWidth}
              onLoadSuccess={(e) => onPageLoadSuccess(e)}
            />
          </Document>
        </div>
      </div>
    </FullScreen>
  ) : (
    <Spinner />
  )

  return (
    <div className='window-wrapper' ref={myRef} >
      {documentMarkup}
    </div>
  )
}

DocumentWindow.propTypes = {
  file: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
}

export default DocumentWindow
